import { GoogleDriveLoginComponent } from './../google-drive-auth-config/components/google-drive-login/google-drive-login.component';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { GoogleAuthInterceptor } from './interceptors/google-auth.interceptor';
import { NbButtonModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { GoogleModule } from '@shared/modules/google/google.module';

@NgModule({
  declarations: [GoogleDriveLoginComponent],
  imports: [
    GoogleModule,
    SharedModule,
    HttpClientModule,
    NbButtonModule,
    TranslateModule
  ],
  providers: [],
  exports: [GoogleDriveLoginComponent]
})
export class GoogleDriveAuthConfigModule { }